// extracted by mini-css-extract-plugin
export default {"gap12":"ROwRVXknSeWWTPez5oTC","fadeIn":"MVjw72WEAj03ZirCe0bq","summaryCard":"uO0_o4Zty_bScrb_YMOr"};